export interface Vendor {
  _id: string;
  name: string;
}

export interface VendorSearchFilters {
  name?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
}

// Mapper functions
export const mapVendorResponse = (response: any): Vendor => {
  return {
    _id: response._id,
    name: response.name,
  };
};

export const mapVendorsResponse = (response: any): Vendor[] => {
  if (!response.data || !Array.isArray(response.data?.vendors)) {
    return [];
  }
  return response.data.vendors.map(mapVendorResponse);
};
